import { Component, Inject, OnInit, AfterContentChecked } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GetCompanyAndUsersData } from 'src/app/services/get-company-and-users-data/get-company-and-users-data.service';
import { GrievanceServicesService } from '../../__grievance-services/grievance-services.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-or-edit-grievance',
  templateUrl: './add-or-edit-grievance.component.html',
  styleUrls: ['./add-or-edit-grievance.component.scss'],
})
export class AddOrEditGrievanceComponent  implements OnInit {
  
  grievanceForm!: FormGroup;
  grievanceTypes!: { key: string; value: string; }[];
  statusType!: {key:string, value:string, count: number}[];
  priorities = ['High', 'Medium', 'Low'];
  isAddressGrievance = false;
  
  getAllEmpData: any = [];
  
  constructor(public dialogRef: MatDialogRef<AddOrEditGrievanceComponent>, @Inject(MAT_DIALOG_DATA) public assetdata: any, private fb: FormBuilder, private getCompanyAndUsersData: GetCompanyAndUsersData, private grievanceServicesService: GrievanceServicesService, public toastr: ToastrService) { }
  
  ngOnInit() {
    
    this.getEmpList();
    
    this.grievanceForm = this.fb.group({
      grievanceType: ['', Validators.required],
      againstWhom: ['', Validators.required],
      whomToSent: ['', Validators.required],
      priority: ['', Validators.required],
      reason: ['', [Validators.required, Validators.maxLength(255)]]
    });
    
    this.grievanceTypes = this.grievanceServicesService.grievanceTypes;
    this.statusType = this.grievanceServicesService.statusType;

    
    if(this.assetdata?.tabType ===  'addressGrievance'){
      this.isAddressGrievance = true;
      this.grievanceForm = this.fb.group({
        status: ['', Validators.required],
        commentFromReceiver: ['', [Validators.required, Validators.maxLength(255)]]
      });
    }
    
    if(this.assetdata?.modalData){

      if(this.assetdata?.tabType ===  'addressGrievance'){
        this.grievanceForm.get('status')?.patchValue(this.assetdata?.modalData.status);
        this.grievanceForm.get('commentFromReceiver')?.patchValue(this.assetdata?.modalData.commentFromReceiver);
      } else {        
        this.grievanceForm.get('grievanceType')?.patchValue(this.assetdata?.modalData.grievanceTypeKey);
        this.grievanceForm.get('againstWhom')?.patchValue(this.assetdata?.modalData.againstWhom);     
        this.grievanceForm.get('whomToSent')?.patchValue(this.assetdata?.modalData.whomToSent);     
        this.grievanceForm.get('priority')?.patchValue(this.assetdata?.modalData.priority);
        this.grievanceForm.get('reason')?.patchValue(this.assetdata?.modalData.reason);     
      }
    }
  }
  
  
  getEmpList(){
    this.getCompanyAndUsersData.getAllEmployeeByCompanyID().subscribe({
      next: (response: any) => {
        this.getAllEmpData = response.data;
        if(this.assetdata?.modalData){
          this.getAllEmpData.map( (data:any) => {
            const fullName = data.firstName +' '+ data.lastName;
            if(fullName == this.assetdata?.modalData.againstWhom) this.grievanceForm.get('againstWhom')?.patchValue(data);
            if(fullName == this.assetdata?.modalData.whomToSent) this.grievanceForm.get('whomToSent')?.patchValue(data);
          });
        }
      },
      error: (error: any) => {},
      complete: () => {}
    });
  }
  
  
  onSubmit(): void {
    const diagRef = this.dialogRef;
    this.grievanceForm.markAllAsTouched();    

    if (this.grievanceForm.valid && !this.isAddressGrievance) {

      let raisedData:any, resolverData:any;
      this.getCompanyAndUsersData.getEmpDetail(this.grievanceForm.value.againstWhom.id, this.grievanceForm.value.whomToSent.id).subscribe({
        next: (data:any) => {
          raisedData = data.raisedId.data[0];
          resolverData = data.resolverId.data[0];
          
          let addData = {
            "grievanceType": this.grievanceForm.value.grievanceType,
            "againstWhom": this.grievanceForm.value.againstWhom.firstName+' '+this.grievanceForm.value.againstWhom.lastName,
            "whomToSent": this.grievanceForm.value.whomToSent.firstName+' '+this.grievanceForm.value.whomToSent.lastName,
            "priority": this.grievanceForm.value.priority, 
            "reason": this.grievanceForm.value.reason,
            
            "id": null,
            "companyId": Number(this.getCompanyAndUsersData.loggedInUserCompanyID),
            "userId": Number(this.getCompanyAndUsersData.loggedInUserId),
            "fiscalYear": this.getCompanyAndUsersData.loggedInCompanyFiscalyear,
            "year": this.getCompanyAndUsersData.currentFinancialYear,
            
            "raisedBy": this.getCompanyAndUsersData.loggedInUserName,
            "raisedEmailId": this.getCompanyAndUsersData.loggedInUserEmail,
            "resolverUserId": this.grievanceForm.value.whomToSent.id,
            "resolverEmailId": resolverData?.officialEmail,
          }
          
          if(this.assetdata?.modalData){
            addData.companyId = Number(this.assetdata?.modalData.companyId);
            addData.userId = Number(this.assetdata?.modalData.userId);
            addData.fiscalYear = this.assetdata?.modalData.fiscalYear;
            addData.year = this.assetdata?.modalData.year;
            addData.id = this.assetdata?.modalData.id;
          }
          
          
          // Add Or Edit Grievance submit
          this.grievanceServicesService.addOrUpdateGrievance(addData).subscribe({
            next:(value:any) => {
              diagRef.close(value);
            },
            error:(err:any) => {
              diagRef.close(false);
              this.toastr.error(err.message);
            }
          });
        }
      });
    } else if(this.grievanceForm.valid && this.isAddressGrievance){
      let addData = {
        "id": this.assetdata?.modalData?.id,
        "resolverUserId": this.assetdata?.modalData?.resolverUserId,
        "status": this.grievanceForm.value.status,
        "commentFromReceiver": this.grievanceForm.value.commentFromReceiver,
      }
      
      // Add Or Edit Address Grievance submit
      this.grievanceServicesService.updateByResolver(addData).subscribe({
        next:(value:any) => {
          diagRef.close(value);
        },
        error:(err:any) => {
          diagRef.close(false);
          this.toastr.error(err.message);
        }
      }); 
    }
  }
}
